import axios from 'axios';
import React, { forwardRef, useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom';
import { BASE_URL3 } from '../../config/axios';
import { formatCurrencyIndian } from '../../components/CustomFunctions';
import header from '../../assets/images/image.png'
import footer from '../../assets/images/image2.png'
import background from '../../assets/images/image3.png'
import ReactDOMServer from "react-dom/server";
import { formatDateDD_MM_YYYY } from '../../components/Date';

const QuotationManagement = React.forwardRef((props, ref) => {
  const [pages, setPages] = useState([]);
  const [isClient, setIsClient] = useState(false);
  const [quatationList, setQuatationList] = useState([]);
  const [notesList, setNotesList] = useState([]);      // ["note 1", "note 2", ...]
  const [newNote, setNewNote] = useState('');
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingText, setEditingText] = useState('');
  // previewData aaye (Add Quotation modal ka preview) to API/route ki jagah wahi use hota hai
  const { id: routeId } = useParams();
  const previewData = props.previewData;
  const id = previewData ? previewData.id : routeId;

  const getInvoiceData = async () => {
    try {
      const res = await axios.get(`${BASE_URL3}/project/quotations/`);
      setQuatationList(res.data);
    } catch (err) {
    }
  };

  useEffect(() => {
    if (previewData) {
      setQuatationList([previewData]);
    } else {
      getInvoiceData();
    }
  }, [previewData]);

  const filteredData = quatationList.filter(i => i.id === id);

  const allData = Object.assign({}, ...filteredData);
  const tableDataMap = filteredData.flatMap(i => i.structured_field || []);
  const NOTESdATA = filteredData.flatMap(i => i.notes || []);
  const terms_and_conditions = filteredData.flatMap(i => i.termsandconditions || []);
  const RateMap = filteredData.flatMap(i => i.rate || []);

  const ContentData = (
    <div className='content-container'
      style={{
        paddingTop: '20px',
        paddingBottom: '20px',
        overflow: 'hidden',
        wordWrap: "break-word",
      }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '30px',
        color: 'black'
      }}>
        <div>
          <strong>Ref No.:{allData.ref_no}</strong>
        </div>
        <div style={{ textAlign: 'right' }}>
          <strong>Date: {formatDateDD_MM_YYYY(allData.date)}</strong>
        </div>
      </div>
      <div>
        <p>To,</p>
        <p>{allData?.to}</p>
        <p><strong>Subject:</strong>{allData.subject}</p>
        <p><strong>Project Details:</strong>{allData.project_details}</p>
        <p>Dear Sir,
        </p>
        <p>We are thankful and greatly privileged to be given this chance to quote for consultancy services. We have
          evaluated the project in detail, as well as our capacity to execute the project, and are confident of executing the
          as per best industry practice and within the time frame, to complete satisfaction of all the stake holders.</p>

        <p>Our detailed proposal is mentioned below:</p>
      </div>

      {tableDataMap.map((tableItem, tableIndex) => (
        <table
          key={tableIndex}
          className="quotationtable-margin-bottom"
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            marginBottom: '30px',
            border: '1px solid black',
          }}
        >
          <thead>
            <tr style={{ backgroundColor: '#eaf2f8' }}>
              <th
                style={{
                  border: '1px solid black',
                  padding: '8px',
                  textAlign: 'left',
                  color: 'black',
                  background: `#e5dfec`
                }}>
                S.No.
              </th>
              {tableItem?.Data?.map((col, colIndex) => (
                <th
                  key={colIndex}
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                    textAlign: colIndex === tableItem.Data.length - 1 ? 'right' : 'left',
                    color: 'black',
                    background: `#e5dfec`
                  }}
                >
                  {col.heading}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {tableItem?.Data?.[0]?.Data?.map((_, rowIndex) => (
              <tr key={rowIndex}>
                <td
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                    textAlign: 'left',
                  }}
                >
                  {rowIndex + 1}.
                </td>

                {tableItem?.Data?.map((col, colIndex) => {
                  const isLastColumn = colIndex === tableItem.Data.length - 1;
                  const value = col?.Data?.[rowIndex]?.item || '';

                  return (
                    <td
                      key={colIndex}
                      style={{
                        border: '1px solid black',
                        padding: '8px',
                        textAlign: isLastColumn ? 'right' : 'left',
                      }}
                    >
                      {isLastColumn && !isNaN(value) && value !== ''
                        ? <>
                          ₹{formatCurrencyIndian(value)}
                        </>
                        : value}
                    </td>
                  );
                })}
              </tr>
            ))}

            {/* Used for / worktype rate row */}
            <tr style={{ backgroundColor: '#eaf2f8' }}>
              <td
                style={{
                  border: '1px solid black',
                  padding: '8px',
                  fontWeight: 'bold',
                  color: 'black',
                  background: `#e5dfec`
                }}></td>
              <td
                style={{
                  border: '1px solid black',
                  padding: '8px',
                  fontWeight: 'bold',
                  color: 'black',
                  textAlign: `right`,
                  background: `#e5dfec`
                }}
                colSpan={tableItem?.Data?.length - 1}
              >
                {tableItem.usedfor}
              </td>
              <td
                style={{
                  border: '1px solid black',
                  padding: '8px',
                  textAlign: 'right',
                  fontWeight: 'bold',
                  color: 'black',
                  background: `#e5dfec`
                }}
              >
                ₹{formatCurrencyIndian(tableItem.worktype_rate)}
              </td>
            </tr>

            {/* Final total row */}
            <tr style={{ backgroundColor: '#eaf2f8' }}>
              <td
                style={{
                  border: '1px solid black',
                  padding: '8px',
                  fontWeight: 'bold',
                  color: 'black',
                  background: `#e5dfec`
                }}></td>
              <td
                style={{
                  border: '1px solid black',
                  padding: '8px',
                  fontWeight: 'bold',
                  color: 'black',
                  textAlign: `right`,
                  background: `#e5dfec`
                }}
                colSpan={tableItem?.Data?.length - 1}
              >
                Total Amount
              </td>
              <td
                style={{
                  border: '1px solid black',
                  padding: '8px',
                  textAlign: 'right',
                  fontWeight: 'bold',
                  color: 'black',
                  background: `#e5dfec`
                }}
              >
                ₹{formatCurrencyIndian(tableItem.total)}
              </td>
            </tr>
          </tbody>
        </table>
      ))}

      <p> *GST will be charged extra as applicable at the time of payment.</p>

      <div>
        <table
          className=""
          style={{
            width: '100%',
            borderCollapse: 'collapse',
            marginBottom: '30px',
            border: '1px solid black',
          }}
        >
          <thead>
            <tr style={{ backgroundColor: '#eaf2f8' }}>
              <th
                style={{
                  border: '1px solid black',
                  padding: '8px',
                  textAlign: 'left',
                  color: 'black',
                  background: `#e5dfec`
                }}>
                S.No.
              </th>
              <th
                style={{
                  border: '1px solid black',
                  padding: '8px',
                  textAlign: 'left',
                  color: 'black',
                  background: `#e5dfec`
                }}
              >
                Description
              </th>
              <th
                style={{
                  border: '1px solid black',
                  padding: '8px',
                  color: 'black',
                  background: `#e5dfec`,
                  textAlign: `right`
                }}
              >
                Amount
              </th>
            </tr>
          </thead>

          <tbody>
            {RateMap.map((i, index) => (
              <tr key={index}>
                <td
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                    textAlign: 'left',
                    background: index === RateMap.length - 1 ? '#e5dfec' : 'transparent',
                    fontWeight: index === RateMap.length - 1 ? `bold` : 'normal',
                  }}
                >
                  {index + 1}.
                </td>

                <td
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                    fontWeight: index === RateMap.length - 1 ? `bold` : 'normal',
                    background: index === RateMap.length - 1 ? '#e5dfec' : 'transparent',
                  }}
                >
                  {i.description}
                </td>

                <td
                  style={{
                    border: '1px solid black',
                    padding: '8px',
                    textAlign: `right`,
                    fontWeight: index === RateMap.length - 1 ? `bold` : 'normal',
                    background: index === RateMap.length - 1 ? '#e5dfec' : 'transparent',
                  }}
                >
                  ₹{formatCurrencyIndian(i.amount)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <p style={{
          fontWeight: 'bold',
          color: 'black',
          borderBottom: '1px solid black',
          paddingBottom: '5px',
          display: 'inline-block',
          marginTop: `20px`
        }}>NOTE</p>
        <ul style={{ listStyleType: 'none', paddingLeft: '0', fontSize: '15px' }}>
          {NOTESdATA.map((note, noteIndex) =>
            note.data.map((desc, descIndex) => (
              <li
                key={`${noteIndex}-${descIndex}`}
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  marginBottom: '8px',
                }}
              >
                <span
                  style={{
                    textAlign: 'center',
                    fontSize: '20px',
                    lineHeight: '1.2',
                    paddingRight: `20px`
                  }}
                >
                  •
                </span>
                <span style={{ flex: 1, textAlign: 'justify' }}>
                  {desc.description}
                </span>
              </li>
            ))
          )}
        </ul>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <p style={{
          fontWeight: 'bold',
          color: 'black',
          borderBottom: '1px solid black',
          paddingBottom: '5px',
          display: 'inline-block'
        }}>PAYMENT TERMS AND CONDITION</p>
        <ul style={{ listStyleType: 'none', paddingLeft: '0', fontSize: '15px' }}>
          {terms_and_conditions.map((i, index) => (
            <li style={{
              display: 'flex',
              alignItems: 'flex-start',
              marginBottom: '8px',
            }} key={index}>
              <span
                style={{
                  textAlign: 'center',
                  fontSize: '20px',
                  lineHeight: '1.2',
                  paddingRight: `20px`
                }}
              >
                •
              </span>
              <span style={{ flex: 1, textAlign: 'justify' }}> {i.item}</span>
            </li>
          ))}
        </ul>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <p style={{
          fontWeight: 'bold',
          color: 'black',
          borderBottom: '1px solid black',
          paddingBottom: '5px',
          display: 'inline-block'
        }}>PAYMENT DETAILS</p>
        <ul style={{ paddingLeft: '0', fontSize: `15px` }}>
          <li><span style={{ paddingRight: `20px`, fontSize: `20px` }}></span>Banking Name: {allData?.subcompany?.company_name}</li>
          <li><span style={{ paddingRight: `20px`, fontSize: `20px` }}></span>Bank Name: {allData?.subcompany?.bank_name}</li>
          <li><span style={{ paddingRight: `20px`, fontSize: `20px` }}></span>A/c No.: {allData?.subcompany?.account_number}</li>
          <li><span style={{ paddingRight: `20px`, fontSize: `20px` }}></span>Branch & IFS Code: {allData?.subcompany?.branch_name} & {allData?.subcompany?.ifsc_code}</li>
          <li><span style={{ paddingRight: `20px`, fontSize: `20px` }}></span>GSTIN/UIN: {allData?.subcompany?.company_gst}</li>
        </ul>
      </div>

      <div style={{ marginBottom: '80px' }}>
        <p>We are assuring us of our best service as always.</p>
        <p>Sincerely Yours,</p>
        <p>For Saptagon Asia Private Limited
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <p style={{
          fontWeight: 'bold',
          color: 'black'
        }}>Mr. Abhinav Sharma</p>
        {/* <p>Senior Manager</p> */}
        <p>Mob: 7006837899</p>
        <p>Email ID: lab.machinery@saptagon.com
        </p>
      </div>
    </div>
  );

  const ContentDataMemo = useMemo(() => ContentData, [quatationList]);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const fontSize = 13;
  const pageSizeToUse = "A4";

  const getImageSource = (image) => {
    if (!image) return null;
    return image instanceof File ? URL.createObjectURL(image) : image;
  };

  const getBgImageStyle = () => {
    if (!background) return {};

    const imageUrl = getImageSource(background);
    return {
      backgroundImage: `url(${imageUrl})`,
      backgroundSize: `100%`,
      transform: "none",
      backgroundRepeat: 'no-repeat',
    };
  };

  const getPaperDimensions = (size) => {
    switch (size) {
      case "A4":
        return { width: "210mm", height: "297mm" };
      case "A3":
        return { width: "297mm", height: "420mm" };
      case "letter":
        return { width: "216mm", height: "279mm" };
      default:
        return { width: "210mm", height: "297mm" };
    }
  };

  const mmToPx = (mm) => (parseFloat(mm) / 25.4) * 96;

  const getPageLayout = (pageSize, fontSize) => {
    const pageDimensions = getPaperDimensions(pageSize);
    const pageHeightPx = mmToPx(pageDimensions.height);
    const pageWidthPx = mmToPx(pageDimensions.width);
    fontSize = fontSize ?? 13
    let headerHeight, footerHeight;
    const paddingLeft = 50;
    const paddingRight = 50;

    if (pageSize === "A3") {
      headerHeight = Math.max(80, fontSize * 2);
      footerHeight = Math.max(80, fontSize * 2.5);
    } else if (pageSize === "letter") {
      headerHeight = Math.max(120, fontSize * 1.5);
      footerHeight = Math.max(120, fontSize * 2);
    } else {
      headerHeight = Math.max(140, fontSize * 1.8);   // 120px image + 20px gap (CSS --slip-header-h)
      footerHeight = Math.max(120, fontSize * 2.2);
    }

    const usableHeight =
      pageHeightPx -
      (headerHeight ? headerHeight : 20) -
      (footerHeight ? footerHeight : 20);
    const usableWidth = pageWidthPx - paddingLeft - paddingRight;

    return {
      pageDimensions,
      pageHeightPx,
      pageWidthPx,
      headerHeight,
      footerHeight,
      paddingLeft,
      paddingRight,
      usableHeight,
      usableWidth,
    };
  };

  // Split hui table ke piece par original table ki styling wapas lagata hai
  const cloneTableShell = (table) => {
    const cloneTable = document.createElement("table");
    cloneTable.style.cssText = table.style.cssText;
    cloneTable.className = table.className;
    return cloneTable;
  };

  const splitHtmlContentIntoPages = (inputContent, pageSize, fontSize) => {
    if (!isClient) return [];
    const layout = getPageLayout(pageSize, fontSize);
    let htmlContent = formatContentForPrint(inputContent || "");

    const tempContainer = document.createElement("div");
    tempContainer.style.position = "absolute";
    tempContainer.style.visibility = "hidden";
    tempContainer.style.left = "-9999px";
    tempContainer.style.top = "0";
    tempContainer.style.width = layout.usableWidth + "px";
    tempContainer.style.fontSize = `${fontSize}px`;
    tempContainer.style.lineHeight = pageSize === "A3" ? "1.6" : "1.5";
    tempContainer.style.fontFamily = "Arial, sans-serif";
    tempContainer.style.boxSizing = "border-box";
    tempContainer.style.wordWrap = "break-word";
    tempContainer.style.overflowWrap = "break-word";
    tempContainer.style.whiteSpace = "normal";
    tempContainer.style.margin = "0";
    tempContainer.style.padding = "0";
    tempContainer.style.border = "none";
    tempContainer.style.backgroundColor = "white";
    tempContainer.style.color = "#666";

    document.body.appendChild(tempContainer);

    const pages = [];
    let currentPageHtml = "";

    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, "text/html");
    const blocks = Array.from(doc.body.childNodes);

    const lineHeightMultiplier = pageSize === "A3" ? 1.6 : 1.5;
    const lineHeightPx = fontSize * lineHeightMultiplier;
    const safetyBufferPx = Math.ceil(lineHeightPx * 0.25);
    const maxHeight = layout.usableHeight - safetyBufferPx;

    for (let i = 0; i < blocks.length; i++) {
      const block = blocks[i];
      const blockHtml = block.outerHTML ?? (block.textContent ?? "");

      tempContainer.innerHTML = currentPageHtml + blockHtml;
      let newHeight = tempContainer.scrollHeight;

      if (newHeight <= maxHeight) {
        currentPageHtml += blockHtml;
        continue;
      }

      if (currentPageHtml && currentPageHtml.trim() !== "") {
        pages.push(currentPageHtml);
        currentPageHtml = "";
        tempContainer.innerHTML = blockHtml;
        newHeight = tempContainer.scrollHeight;
        if (newHeight <= maxHeight) {
          currentPageHtml = blockHtml;
          continue;
        }
      }

      if (block.nodeType === Node.ELEMENT_NODE) {
        if (block.nodeName.toUpperCase() === "TABLE") {
          const table = block;
          const rows = Array.from(table.querySelectorAll("tbody tr"));
          const thead = table.querySelector("thead");
          let rowIndex = 0;

          while (rowIndex < rows.length) {
            const cloneTable = cloneTableShell(table);
            if (thead) cloneTable.appendChild(thead.cloneNode(true));

            while (rowIndex < rows.length) {
              const rowClone = rows[rowIndex].cloneNode(true);
              cloneTable.appendChild(rowClone);
              tempContainer.innerHTML = currentPageHtml + cloneTable.outerHTML;

              if (tempContainer.scrollHeight > maxHeight) {
                cloneTable.removeChild(rowClone);
                break;
              }
              rowIndex++;
            }

            currentPageHtml += cloneTable.outerHTML;

            if (rowIndex < rows.length) {
              pages.push(currentPageHtml);
              currentPageHtml = "";
            }
          }

          continue;
        }

        else if (block.nodeName.toUpperCase() === "DIV") {
          const children = Array.from(block.childNodes);
          let childIndex = 0;

          while (childIndex < children.length) {
            const child = children[childIndex];

            if (child.nodeType === Node.ELEMENT_NODE && child.nodeName.toUpperCase() === "TABLE") {

              const table = child;
              const rows = Array.from(table.querySelectorAll("tbody tr"));
              const thead = table.querySelector("thead");
              let rowIndex = 0;

              while (rowIndex < rows.length) {
                const cloneTable = cloneTableShell(table);
                if (thead) cloneTable.appendChild(thead.cloneNode(true));

                while (rowIndex < rows.length) {
                  const rowClone = rows[rowIndex].cloneNode(true);
                  cloneTable.appendChild(rowClone);
                  tempContainer.innerHTML = currentPageHtml + cloneTable.outerHTML;

                  if (tempContainer.scrollHeight > maxHeight) {
                    cloneTable.removeChild(rowClone);
                    break;
                  }
                  rowIndex++;
                }

                currentPageHtml += cloneTable.outerHTML;

                if (rowIndex < rows.length) {
                  pages.push(currentPageHtml);
                  currentPageHtml = "";
                }
              }
              childIndex++;
            }
            else if (child.nodeType === Node.TEXT_NODE) {

              const words = child.textContent.trim().split(/\s+/);
              let start = 0;
              while (start < words.length) {
                let left = 1, right = words.length - start, best = 0;
                while (left <= right) {
                  const mid = Math.floor((left + right) / 2);
                  const testText = words.slice(start, start + mid).join(" ");
                  tempContainer.innerHTML = currentPageHtml + `<p>${testText}</p>`;
                  if (tempContainer.scrollHeight <= maxHeight) {
                    best = mid;
                    left = mid + 1;
                  } else {
                    right = mid - 1;
                  }
                }
                if (best === 0) {
                  currentPageHtml += `<p>${words[start]}</p>`;
                  start++;
                } else {
                  currentPageHtml += `<p>${words.slice(start, start + best).join(" ")}</p>`;
                  start += best;
                }
                pages.push(currentPageHtml);
                currentPageHtml = "";
              }
              childIndex++;
            } else if (child.nodeType === Node.ELEMENT_NODE) {

              const clone = child.cloneNode(true);
              tempContainer.innerHTML = currentPageHtml + clone.outerHTML;
              if (tempContainer.scrollHeight <= maxHeight) {
                currentPageHtml += clone.outerHTML;
              } else {
                pages.push(currentPageHtml);
                currentPageHtml = clone.outerHTML;
              }
              childIndex++;
            }
          }
          continue;
        }
      }

      if (block.nodeType === Node.ELEMENT_NODE && block.childNodes?.length > 0) {
        const children = Array.from(block.childNodes);
        let childIndex = 0;
        while (childIndex < children.length) {
          const clone = block.cloneNode(false);
          let appended = false;
          for (let c = childIndex; c < children.length; c++) {
            clone.appendChild(children[c].cloneNode(true));
            tempContainer.innerHTML = clone.outerHTML;
            if (tempContainer.scrollHeight > maxHeight) {
              clone.removeChild(clone.lastChild);
              break;
            } else {
              appended = true;
              childIndex = c + 1;
            }
          }
          if (!appended) {
            const singleChild = children[childIndex];
            if (singleChild.nodeType === Node.TEXT_NODE) {
              const words = singleChild.textContent.trim().split(/\s+/);
              let left = 0,
                right = words.length,
                best = 0;
              while (left <= right) {
                const mid = Math.floor((left + right) / 2);
                const testText = words.slice(0, mid).join(" ");
                tempContainer.innerHTML = `<p>${testText}</p>`;
                if (tempContainer.scrollHeight <= maxHeight && mid > 0) {
                  best = mid;
                  left = mid + 1;
                } else {
                  right = mid - 1;
                }
              }
              if (best === 0) {
                clone.appendChild(document.createTextNode(singleChild.textContent));
                childIndex++;
              } else {
                const fittingText = words.slice(0, best).join(" ");
                clone.appendChild(document.createTextNode(fittingText));
                const remainingText = words.slice(best).join(" ");
                children[childIndex] = document.createTextNode(remainingText);
              }
            } else {
              clone.appendChild(singleChild.cloneNode(true));
              childIndex++;
            }
          }
          currentPageHtml += clone.outerHTML;
          pages.push(currentPageHtml);
          currentPageHtml = "";
        }
        continue;
      }

      const text = block.textContent ?? "";
      if (text.trim()) {
        const words = text.trim().split(/\s+/);
        let start = 0;
        while (start < words.length) {
          let left = 1,
            right = words.length - start,
            best = 0;
          while (left <= right) {
            const mid = Math.floor((left + right) / 2);
            const candidate = words.slice(start, start + mid).join(" ");
            tempContainer.innerHTML = currentPageHtml + `<p>${candidate}</p>`;
            if (tempContainer.scrollHeight <= maxHeight) {
              best = mid;
              left = mid + 1;
            } else {
              right = mid - 1;
            }
          }
          if (best === 0) {
            currentPageHtml += `<p>${words[start]}</p>`;
            start++;
          } else {
            currentPageHtml += `<p>${words.slice(start, start + best).join(" ")}</p>`;
            start += best;
          }
          pages.push(currentPageHtml);
          currentPageHtml = "";
        }
      }
    }

    if (currentPageHtml && currentPageHtml.trim() !== "") {
      pages.push(currentPageHtml);
    }

    document.body.removeChild(tempContainer);

    return pages.filter((p) => p && p.trim().length > 10);
  };

  const formatContentForPrint = (content) => {
    if (!content) return "";
    return content
      .replace(/\n\n/g, "</p><p>")
      .replace(/\n/g, "<br>")
      .replace(/^\s*/, "<p>")
      .replace(/\s*$/, "</p>")
      .replace(/<p><\/p>/g, "")
      .replace(/<p>\s*<\/p>/g, "");
  };

  useEffect(() => {
    if (ContentDataMemo) {
      let finalContent = "";
      if (typeof ContentDataMemo === "string") {
        finalContent = ContentDataMemo;
      } else {
        finalContent = ReactDOMServer.renderToStaticMarkup(ContentDataMemo);
      }

      const contentPages = splitHtmlContentIntoPages(
        finalContent,
        pageSizeToUse,
        fontSize,
      );
      setPages(contentPages);
    }
  }, [ContentDataMemo, isClient, pageSizeToUse, fontSize]);

  const layoutForRender = getPageLayout(pageSizeToUse, fontSize);

  // Size/overflow/header-footer ki height ab QuotationSlip.css se control hoti hai
  return (
    <>
      <div className="letter-template-container-e-e" ref={ref}>
        {(pages.length > 0 ? pages : [null]).map((content, index) => (
          <div
            key={index}
            className='letter-page-e-e'
            style={{
              pageBreakAfter: index === pages.length - 1 ? "auto" : "always",
            }}
          >
            {/* Background Image */}
            {background && (
              <div
                className="letter-template-bg-image-e"
                style={getBgImageStyle()}
              />
            )}

            {/* Header */}
            {header && (
              <div className="letter-template-header-e">
                <div className='salaryslip-header-e'>
                  <img
                    src={header}
                    alt="Header"
                    className="letter-template-header-full-image"
                  />
                </div>
              </div>
            )}

            {/* Main Content */}
            <div
              className="letter-template-body-e-e"
              style={{
                paddingLeft: layoutForRender.paddingLeft + "px",
                paddingRight: layoutForRender.paddingRight + "px",
              }}
            >
              <div
                className="letter-template-content-placeholder-e"
                style={{
                  fontSize: `${fontSize}px`,
                  lineHeight: "1.5",
                  boxSizing: "border-box",
                }}
                dangerouslySetInnerHTML={{
                  __html: content
                }}
              />
            </div>

            {/* Footer */}
            {footer && (
              <div className="letter-template-footer-e">
                <img
                  src={footer}
                  alt="Footer"
                  className="letter-template-footer-full-image"
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
});
export { QuotationManagement };









